import { FC } from 'react'
import { useTranslation } from 'react-i18next'

export const NoOptionFound: FC = ({ label }: { label?: string }) => {
  const { t } = useTranslation()
  return (
    <div className="selectw-option selectw-no-options-found selectw-option-disabled">
      <span>{label ?? t('common.select.noResultFound')}</span>
    </div>
  )
}
NoOptionFound.displayName = 'SelectNoOptionFound'
